// CORE-1735 slice 17 (D-120, QA V06) — Live icon «chat» from the published set v4.2
// (Confluence 110461314, archive reference-icons-v4.2): geometry as shipped, strokes 1.8,
// paint from the caller (`color` — solid or an ink gradient reference), the inner
// highlight through `filter` (the toolbar's «live-polish»), the slash cut by `cut`.
import React from 'react';
import Svg, { G, Path } from 'react-native-svg';
import type { LiveGlyphProps } from '../types';

export const Chat: React.FC<LiveGlyphProps> = ({ size, color, filter }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <G filter={filter} fill={color} fillRule="evenodd">
    <Path d="M5.5 3h12A5.5 5.5 0 0 1 23 8.5v5a5.5 5.5 0 0 1-5.5 5.5H16l4 4-7-3.3H7.5A6.5 6.5 0 0 1 1 13.2V8.5A5 5 0 0 1 5.5 3Z" fill={color} />
    </G>
  </Svg>
);
